import { Box } from '@chakra-ui/react';
import ListContentTypeField from './list-content-type-field';

interface Props {
  workspaceId: string;
  contentTypeId: string;
}

export default function ContentTypeActions({ workspaceId, contentTypeId }: Props) {
  return (
    <Box py={5}>
      <ListContentTypeField workspaceId={workspaceId} contentTypeId={contentTypeId} />
    </Box>
  );
}
